import React from 'react';

const PromoBannor = () => {
  return (
    <section className="promo-banner">
      <div className="banner-inner-border">

        <div className="banner-content">
          {/* Main Typography */}
          <div className="text-section">
            <h1 className="main-headline">
              LUXURY THAT FITS YOUR <br />
              LIFESTYLE AND YOUR BUDGET!
            </h1>
            
            <div className="sub-header-bar">
              <span className="bhk-info">3, 4 & 5 BHK LUXURY RESIDENCES</span>
              <span className="divider">|</span>
              <span className="location-info">SECTOR 104, GURGAON</span>
            </div>
          </div>

          {/* Price Badge */}
          <div className="price-badge-container">
            <h2 className="project-name">THE LEVAITE RESIDNCENS</h2>
            <div className="price-box">
              <p className="price-label">STARTING AT JUST</p>
              <p className="price-amount">₹2.99 CR.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromoBannor;